<template>
    <div></div>
</template>

<script>
    export default {
        name: "Confirmation",
        created () {
            this.$axios.get('/user/confirmation?token=' + this.$route.params.token).then((res) => {
                this.$store.commit('setToken', res.data.access_token);
                this.$message.success(this.$t('notice.email_confirmed'));
                this.$router.replace({ name: 'main' })
            }).catch(() => {
                //this.$message.error(error.response.data.message);
                this.$router.replace({ name: 'main' })
            });
        }
    }
</script>

<style scoped>

</style>